/**
 * Mini Cart Entry Point
 *
 * Mounts the MiniCart component on all pages with [evcs_mini_cart] shortcode.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ShopProvider } from '@/context';
import { MiniCart } from '@/components/MiniCart';

// Find all mini-cart mount points
const mountPoints = document.querySelectorAll('#evcs-mini-cart, .evcs-mini-cart');

mountPoints.forEach((container) => {
  const showIcon = container.getAttribute('data-show-icon') !== 'false';

  const root = createRoot(container);
  root.render(
    <StrictMode>
      <ShopProvider>
        <MiniCart showIcon={showIcon} />
      </ShopProvider>
    </StrictMode>
  );
});
